export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-torsos-all-19ab4e7070a788978c0273f20b8fd9e5.svg";